module.exports = __webpack_public_path__ + "static/back-srevice-aabfccc4d2bf4e1c1cc60868d18b4224.png";